"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../assets/icons/BackHeader"));
const IC_RIGHT_1 = __importDefault(require("../../assets/icons/IC_RIGHT"));
const header_1 = require("../../components/header");
const CustomText_1 = __importDefault(require("../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../navigators/Routes"));
const rootNavigation_1 = require("../../navigators/rootNavigation");
const scale_1 = require("../../utils/scale");
const DisconnectScreen_1 = require("../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const MyPageScreen = (props) => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(header_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                alignSelf: 'center',
            }, title: 'マイページ', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }), onLeftPress: rootNavigation_1.goBack }),
        react_1.default.createElement(react_native_1.ScrollView, { showsVerticalScrollIndicator: false, contentContainerStyle: { paddingBottom: inset.bottom + (0, scale_1.scale)(130) } },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.titleList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: '#292A33',
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8")),
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.boxList, onPress: () => {
                    props.navigation.navigate(Routes_1.default.DELETE_ACCOUNT_SCREEN);
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u4F1A\u54E1\u60C5\u5831"),
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', alignItems: 'center' } },
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: '#292A33',
                            marginRight: (0, scale_1.scale)(8),
                        } }, "\u7121\u6599\u4F1A\u54E1"),
                    react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 }))),
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.boxList, onPress: () => {
                    (0, rootNavigation_1.navigate)(Routes_1.default.CHANGE_ID_SCREEN);
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30E6\u30FC\u30B6\u30FCID\u5909\u66F4"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })),
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.boxList, onPress: () => {
                    props.navigation.navigate(Routes_1.default.DISPLAY_INFORMATION_SCREEN);
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u96FB\u8A71\u756A\u53F7\u30FB\u751F\u5E74\u6708\u65E5"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.CHANGE_PASSWORD), style: styles_1.default.boxList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u5909\u66F4"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                    dispatch(slice_1.default.actions.logout());
                    dispatch(slice_1.default.actions.showToast('ログアウトしました'));
                    (0, rootNavigation_1.reset)({ index: 0, routeName: Routes_1.default.MAINTABBAR });
                }, style: {
                    width: '100%',
                    height: (0, scale_1.scale)(33),
                    padding: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        color: '#D32F2F',
                    } }, "\u30ED\u30B0\u30A2\u30A6\u30C8")),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.titleList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: '#292A33',
                    } }, "\u5404\u7A2E\u901A\u77E5\u8A2D\u5B9A")),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.NOTIFY_SETTING, { type: 'pushnoti' }), style: styles_1.default.boxList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30D7\u30C3\u30B7\u30E5\u901A\u77E5"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })),
            react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.boxList, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.NOTIFY_SETTING, { type: 'boxnoti' }) },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30A2\u30D7\u30EA\u5185\u901A\u77E5\u6B04"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.titleList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(12),
                        lineHeight: (0, scale_1.moderateScale)(18),
                        color: '#292A33',
                    } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u5236\u9650")),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.ACCOUNT_LIMIT_SCREEN, { defaultTabIndex: 0 }), style: styles_1.default.boxList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30DF\u30E5\u30FC\u30C8\u6E08\u307F\u30E6\u30FC\u30B6\u30FC"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.ACCOUNT_LIMIT_SCREEN, { defaultTabIndex: 1 }), style: styles_1.default.boxList },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u30D6\u30ED\u30C3\u30AF\u6E08\u307F\u30E6\u30FC\u30B6\u30FC"),
                react_1.default.createElement(IC_RIGHT_1.default, { width: 20, height: 21 })))));
};
exports.default = MyPageScreen;
